import { Mail } from "lucide-react";

const PricingMore = () => {
  return (
    <div className="w-full bg-white dark:bg-gray-800 py-16">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 dark:text-white">
          Need a Custom Solution?
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
          We offer tailored pricing plans for enterprises and special use cases.
        </p>

        <div className="mt-8">
          <p className="text-gray-500 dark:text-gray-400 max-w-lg mx-auto">
            Contact our team to discuss custom requirements, volume pricing, or
            special features that aren&apos;t covered in our standard plans.
          </p>

          <a
            href="mailto:support@syncai.ltd"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200"
          >
            <Mail className="h-5 w-5" />
            Contact Sales Team
          </a>
        </div>
      </div>
    </div>
  );
};

export default PricingMore;
